// フッターの Cookie 同意設定リンク（.js-consent-settings）の表示を制御する。
// Pandectes は同意バナーの表示対象地域（EU/EEA/英国・米国の一部州）でのみ #reopenBanner の
// リンクにクリックハンドラを付与する。対象外の地域ではリンクを押しても設定ダイアログが開かず
// クッキーポリシーページへ遷移するだけで、フッターに既にある Cookie Policy リンクと重複するため、
// 対象外の地域では表示しない。
// 対象地域かどうかは Pandectes が発火する PandectesInitialized の detail.banner をそのまま使い、
// 対象地域リストをテーマ側に二重で持たない（Pandectes 管理画面での地域変更に追従する）。
//
// Pandectes が初期化されない限りリンクは hidden のままにする。一定時間で表示するフォールバックは
// 置かない。低速回線では対象外の地域でも初期化がタイムアウトに間に合わず、本来出してはいけない
// リンクが表示されてしまうため。初期化されない状況では同意バナー自体も出ず同意を取得していないので、
// 撤回導線も不要と整理している。

(function () {
  const LINK_SELECTOR = '.js-consent-settings';
  const INITIALIZED_EVENT = 'PandectesInitialized';

  window.addEventListener(INITIALIZED_EVENT, (event) => {
    if (!event.detail || !event.detail.banner) return;

    document.querySelectorAll(LINK_SELECTOR).forEach((item) => {
      item.hidden = false;
    });
  });
})();
